import PropTypes from 'prop-types'
import { createUseStyles } from '../../../helpers/createStyles'

const ColorName = ({ name, num, total }) => {
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <h3>{name}</h3>
      <span>
        {num} — {total}
      </span>
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    '& h3': {
      marginBottom: 0,
      marginRight: '0.4em',
      fontSize: '2rem'
    },
    '& span': {
      fontSize: '0.7rem',
      wordSpacing: '0.5em'
    }
  }
})

export const colorNameNumberPropTypes = {
  num: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}

ColorName.propTypes = {
  name: PropTypes.string.isRequired,
  ...colorNameNumberPropTypes
}

export default ColorName
